import { createSlice } from "@reduxjs/toolkit";
import { getMatrixComplianceApi } from "services/matrixCompliance/matrixCompliance.thunks";

const name = "matrixCompliance";
const initialState = {
  matrixComplianceData: null,
};

const extraReducers = (builder) => {
  const { pending, fulfilled, rejected } = getMatrixComplianceApi;
  builder
    .addCase(pending, (state) => {
      state.matrixComplianceData = { loading: true };
    })
    .addCase(fulfilled, (state, action) => {
      state.matrixComplianceData = action.payload.Data;
    })
    .addCase(rejected, (state, action) => {
      state.matrixComplianceData = { error: action.error };
    });
};

const slice = createSlice({ name, initialState, extraReducers });

export const matrixComplianceReducer = slice.reducer;
